import React, { useEffect, useState } from "react";
import { Button, Card, Spinner, Table } from "react-bootstrap";
import { horizon } from "../api/horizon";
import { Link } from "react-router-dom";
import { timelib } from "../utils/time";
import { usePageMetadata } from "../context/PageMetadataContext";
import { useLanguage } from "../context/LanguageContext";
import CopyIcon from "../components/CopyIcon";
import { CardContent } from "../components/Card";
import AdSenseUnit from "../components/AdsenseUnit";
import AdUnit from "../components/AdUnit";

const BlocksPage = () => {
  const { t, language } = useLanguage();
  
  interface Block {
    id: string;
    sequence: number;
    hash: string;
    successful_transaction_count: number;
    failed_transaction_count: number;
    operation_count: number;
    closed_at: string;
  }

  const [blocks, setBlocks] = useState<Block[]>([]);
  const [nextLink, setNextLink] = useState("");
  const [prevLink, setPrevLink] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const {setHeading, setTitle, setDescription} = usePageMetadata();
  
  useEffect(() => {
    setHeading(t('blocks.heading'));
    setTitle(t('blocks.title'));
    setDescription(t('blocks.description'));
  }, [setTitle, setDescription, setHeading, t, language]);
  
  // Fetch ledgers using the provided API function
  const fetchBlocks = async (link: string, page: number) => {
    try {
      setLoading(true);
      const data = await horizon.getLedgers(link);
      //if order asc, reverse the array, and next is prev and prev is next
      if (link=="" || link.indexOf("order=desc") > 0) {
        setBlocks(data._embedded.records);
        setNextLink(data._links.next.href);
        setPrevLink(data._links.prev.href);
      } else {
        setBlocks(data._embedded.records.reverse());
        setNextLink(data._links.prev.href);
        setPrevLink(data._links.next.href);
      }
      
      setCurrentPage(page ? page : 1);
      // Update page number
    } catch (error) {
      console.error("Error fetching blocks:", error);
    } finally {
      setLoading(false);
    }
  };
  
  //refresh time ago every 1 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setBlocks((blocks) =>
        blocks.map((block) => ({ ...block, current_time: Date.now() }))
      );
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  
  // Initial fetch
  useEffect(() => {
    fetchBlocks("", 1);
  }, []);

  return (
    <div className="white-zone">
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
            <div className="col-md-12">
                <Card className="none-radius">
                    <CardContent>
                        <h5 className="card-title" style={{fontSize:"16px",marginBottom:"20px"}}>{t('blocks.title')}</h5>
          <Table hover responsive>
            <thead>
              <tr>
                <th>{t('blocks.sequence')}</th>
                <th>{t('blocks.hash')}</th>
                <th>{t('blocks.transactions')}</th>
                <th>{t('blocks.operations')}</th>
                <th>{t('blocks.time')}</th>
              </tr>
            </thead>
            <tbody>
              {blocks.map((block) => (
                <tr key={block.id}>
                  <td>
                    <Link className="text-decoration-none" to={`/block/${block.sequence}`}>
                      {block.sequence}
                    </Link>
                  </td>
                  <td>
                    <Link className="text-decoration-none" to={`/block/${block.sequence}`}>
                      {block.hash.slice(0, 10)}...
                    </Link>
                    {" "}<CopyIcon textToCopy={block.hash} />
                  </td>
                  <td>
                    <Link className="text-decoration-none" to={`/block/${block.sequence}`}>
                      <span className="text-success"> 
                        {block.successful_transaction_count} {t('blocks.successful')}
                      </span>,{" "}
                      <span className="text-muted">
                        {block.failed_transaction_count} {t('blocks.failed')}
                      </span> 
                    </Link>
                  </td>
                  <td>{block.operation_count}</td>
                  <td>
                    {timelib.timeAgo(block.closed_at, language)}{" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Pagination Controls */}
          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button
              variant="primary"
              size="sm"
              onClick={() => fetchBlocks(prevLink, currentPage-1)}
              disabled={!prevLink || loading || currentPage === 1}
            >
              {t('pagination.previous')}
            </Button>

            {/* Current Page Number */}
            <span className="mx-3">{t('pagination.page')} {currentPage}</span>

            <Button
              variant="primary"
              size="sm"
              onClick={() => fetchBlocks(nextLink, currentPage+1)}
              disabled={!nextLink || loading}
            >
              {t('pagination.next')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className="row g-3 mb-4  d-block d-md-none">
        {/* <AdSenseUnit/> */}
        {/* <AdUnit
                  className="67cc9f95aa72d3d47fe128c2"
                  width="300px"
                  height="100px"
                  centered={true}
                /> */}
      </div>
  </div>
      )}
    </div>
  );
};

export default BlocksPage;
